export function cntProps() {
  return {
    contentItem: {
      type: Object,
      default: () => ({})
    },
  } 
}
